import { gql } from '@apollo/client'

export const UPSERT_USER_PROPERTY = gql`
  mutation upsertUserProperty($id: ID, $kind: UserPropertyKind!, $value: String!) {
    upsertUserProperty(id: $id, kind: $kind, value: $value) {
      id
    }
  }
`
